import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeid, resizeFile } from "./../../../../../utils";
import { getStageScreen, setLoading } from "../../../../../redux";
import { validateIncomeProof } from "../../IncomeProof/redux/action";
import Title from "../../../components/Title";
import Webcam from "react-webcam";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import InputTitle from "designs/v1/components/InputTitle";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

const WebcamCapture = ({ handleImg, handleShow, disabled, show }) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    handleImg(imageSrc);
  });

  const handleChangeMode = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClose = (bool) => {
    setImage("");
    handleShow(bool);
  };

  return (
    <>
      {show ? (
        <div className="webcam-container">
          <div className="webcam-img">
            {image == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img src={image} />
            )}
          </div>
          <div>
            {image != "" ? (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setImage("");
                  }}
                  className="btn btn-success mx-2"
                >
                  Retake Image
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    capture();
                  }}
                  className="btn btn-success mx-2"
                >
                  Capture
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary mx-2"
                  >
                    Switch camera
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <button
          className="btn btn-warning btn-sm"
          disabled={disabled}
          onClick={() => handleShow(true)}
        >
          Open Camera
        </button>
      )}
    </>
  );
};

const Signature = ({activeHolder}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const { inputLabelColor } = useSelector((state) => state.theme);
  const [signatureVerificationSuccess, setSignatureVerificationSuccess] =
    useState(false);
  const [isShow, setIsShow] = useState(false);

  const handleShow = (bool) => {
    setIsShow(bool);
  };

  const handleCaptureSign = (img) => {
    uploadSignatureCaptureImg(img);
  };

  const uploadSignatureImageOLD = async (file) => {
    if (!file) return;
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
      return;
    }
    if (file.type === "application/pdf") {
      const fileSize = file.size / 1024 ** 2;
      if (fileSize >= 3) {
        toast.error("Please upload a file smaller than 3MB");
        return;
      }
      let isEncrypted = false;
      dispatch(setLoading(true));
      try {
        const formData = new FormData();
        formData.append("file", file, makeid(6) + ".pdf");
        const resp = await validateIncomeProof(formData);
        isEncrypted = resp.data?.message || false;
        dispatch(setLoading(false));
      } catch (error) {}
      if (isEncrypted) {
        toast.error("Please upload a file without password protected.");
        dispatch(setLoading(false));
        return;
      }
      const formData = new FormData();
      formData.append("sign_img", file, makeid(6) + ".pdf");
      formData.append("file_type", "pdf");
      handleCaptureSign(file)
    //   dispatch(handleFileUpload(formData));
      return;
    }
    const resizedFile = await resizeFile(file);
    const formData = new FormData();
    formData.append("sign_img", resizedFile, makeid(6) + ".JPEG");
    formData.append("file_type", "Image");
    // dispatch(handleFileUpload(formData));
  };


  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
        API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const uploadSignatureImage = async (file) => {
    uploadSignatureCaptureImg(file)
  }

  const token = window.sessionStorage.getItem("token");
  const uploadSignatureCaptureImg = async (imageBase64) => {
    if (!imageBase64) return;

    // Preparing FormData to send in API call
    const formData = new FormData();
    formData.append("sign_img", imageBase64);
    formData.append("holder", activeHolder); // or "3", depending on the logic of how you determine this
    formData.append("file_type", "Image");

    try {
        dispatch(setLoading(true));

        // API endpoint - replace with your actual endpoint
        const apiUrl = `${getApiUrl()}/api/method/kyc_customizations.apis.joint_holder.signature_upload.endpoint`;

        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData,
            headers: { 'Authorization': `Basic ${token}` },
            // headers: {}, // If required
            // credentials: 'include', // If required
        });

        const data = await response.json();
        dispatch(setLoading(false));
        dispatch(getStageScreen());
        if (response.ok) {
            toast.success("Signature captured and uploaded successfully!");
            // Handle success logic here
        } else {
            throw new Error(data.message || "Failed to upload captured signature.");
        }
    } catch (error) {
        dispatch(setLoading(false));
        toast.error(error.message || "An error occurred during the upload.");
    }
};


  return (
    <React.Fragment>
      <Title title="Signature" />
      <div className="col-md-12">
        <div className="form-group">
          <div className="row">
            <div className="col-md-6">
              <InputTitle
                title={"Upload your signature (jpg, png, pdf)"}
                className={"my-1"}
              />
            </div>
          </div>

          {signatureVerificationSuccess ? (
            "Signature Verified"
          ) : (
            <>
            <div className="row">
                <div className="col-md-6">

                
              <div className="file-uploader-container">
                <FileUploader
                  handleChange={(file) => uploadSignatureImage(file)}
                  name="file"
                  types={FILE_TYPES}
                />
              </div>
              <div>
                <label className="my-1 text-muted text-sm">
                  <small>Maximum file size: 4 MB</small>
                </label>
              </div>
              </div>
            </div>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Signature;
